var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, autorun, observable } from "mobx";
export const routeEquals = (a, b) => (a === null || a === void 0 ? void 0 : a.routeName) === (b === null || b === void 0 ? void 0 : b.routeName);
export function createNamedRoute(routeName, parent) {
    return { routeName, parent };
}
export function findMatchingNamedRouteParent(route, candidates) {
    if (!route)
        return null;
    const candidateNames = candidates.map((candidate) => candidate.routeName);
    let currentRoute = route;
    while (currentRoute) {
        if (candidateNames.includes(currentRoute.routeName)) {
            return currentRoute;
        }
        currentRoute = currentRoute.parent;
    }
    return null;
}
const BEFORE_UNLOAD_HANDLER = (e) => e.preventDefault();
export const IAS_PATH = "ias";
export const IAS_UPDATE_PATH = "ias-update";
export class RoutingUIManager {
    constructor() {
        this.previousRoute = null;
        this.previousRouteParams = null;
        this.currentRoute = null;
        this.currentRouteParams = null;
        this.redirectHandlerMap = new Map();
        this.redirectInterceptor = null;
        this.unloadConfirmation = null;
        this.unloadDisposer = null;
        this.unloadConfirmationNeeded = null;
    }
    initialize(initalRoute, initialRouteParams, onNavigate) {
        this.onNavigate = onNavigate;
        void this.userNavigatedTo(initalRoute, initialRouteParams !== null && initialRouteParams !== void 0 ? initialRouteParams : {});
    }
    async userNavigatedTo(route, routeParams) {
        var _a, _b, _c;
        if (this.unloadConfirmation && ((_a = this.unloadConfirmationNeeded) === null || _a === void 0 ? void 0 : _a.call(this))) {
            if (!(await this.unloadConfirmation()))
                return;
        }
        let redirectedRoute = route ? (_b = this.redirectInterceptor) === null || _b === void 0 ? void 0 : _b.call(this, route, routeParams) : undefined;
        if (!redirectedRoute) {
            redirectedRoute = route ? (_c = this.redirectHandlerMap.get(route.routeName)) === null || _c === void 0 ? void 0 : _c(routeParams) : undefined;
        }
        if (!redirectedRoute) {
            this.previousRoute = this.currentRoute;
            this.previousRouteParams = this.currentRouteParams;
            this.currentRoute = route;
            this.currentRouteParams = routeParams;
            this.clearUnloadConfirmation();
        }
        else if ("routeName" in redirectedRoute) {
            this.navigateTo(redirectedRoute);
        }
        else {
            this.navigateTo(redirectedRoute.route, redirectedRoute.routeParams);
        }
    }
    navigateTo(route, routeParams = {}) {
        void this._navigateTo(route, routeParams, false);
    }
    redirectTo(route, routeParams = {}) {
        void this._navigateTo(route, routeParams, true);
    }
    navigateBack() {
        if (this.previousRoute && this.previousRouteParams) {
            this.navigateTo(this.previousRoute, this.previousRouteParams);
            this.previousRoute = null;
            this.previousRouteParams = null;
        }
    }
    async _navigateTo(route, routeParams, isRedirect) {
        var _a, _b, _c, _d;
        if (this.unloadConfirmation && ((_a = this.unloadConfirmationNeeded) === null || _a === void 0 ? void 0 : _a.call(this))) {
            if (!(await this.unloadConfirmation()))
                return;
        }
        let redirectedRoute = (_b = this.redirectInterceptor) === null || _b === void 0 ? void 0 : _b.call(this, route, routeParams);
        if (!redirectedRoute) {
            redirectedRoute = (_c = this.redirectHandlerMap.get(route.routeName)) === null || _c === void 0 ? void 0 : _c(routeParams);
        }
        if (!redirectedRoute) {
            (_d = this.onNavigate) === null || _d === void 0 ? void 0 : _d.call(this, route, routeParams, isRedirect);
            this.previousRoute = this.currentRoute;
            this.previousRouteParams = this.currentRouteParams;
            this.currentRoute = route;
            this.currentRouteParams = routeParams;
            this.clearUnloadConfirmation();
        }
        else if ("routeName" in redirectedRoute) {
            console.log(redirectedRoute);
            this.navigateTo(redirectedRoute);
        }
        else {
            console.log(redirectedRoute);
            this.navigateTo(redirectedRoute.route, redirectedRoute.routeParams);
        }
    }
    registerRedirectInterceptor(interceptor) {
        this.redirectInterceptor = interceptor;
    }
    registerRedirect(route, handler) {
        this.redirectHandlerMap.set(route.routeName, handler);
    }
    registerUnloadHandler(opts) {
        this.unloadConfirmation = opts.confirmation;
        this.unloadConfirmationNeeded = opts.needed;
        this.unloadDisposer = autorun(() => {
            if (opts.needed()) {
                window.addEventListener("beforeunload", BEFORE_UNLOAD_HANDLER);
            }
            else {
                window.removeEventListener("beforeunload", BEFORE_UNLOAD_HANDLER);
            }
        });
    }
    clearUnloadConfirmation() {
        var _a;
        this.unloadConfirmation = null;
        (_a = this.unloadDisposer) === null || _a === void 0 ? void 0 : _a.call(this);
        this.unloadDisposer = null;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], RoutingUIManager.prototype, "previousRoute", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RoutingUIManager.prototype, "previousRouteParams", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RoutingUIManager.prototype, "currentRoute", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RoutingUIManager.prototype, "currentRouteParams", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", Promise)
], RoutingUIManager.prototype, "userNavigatedTo", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object, Boolean]),
    __metadata("design:returntype", Promise)
], RoutingUIManager.prototype, "_navigateTo", null);
